import { RefObject, useState } from "react";

import { useEventListener } from "usehooks-ts";

export function useActive<T extends HTMLElement = HTMLElement>(elementRef: RefObject<T>): boolean {
  const [value, setValue] = useState<boolean>(false);

  const handleMouseDown = () => setValue(true);
  const handleMouseUp = () => setValue(false);

  useEventListener("mousedown", handleMouseDown, elementRef);
  useEventListener("mouseup", handleMouseUp, elementRef);

  return value;
}
